import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import AudioButton from 'aria-viewer/tour/components/buttons/audioButton'
import { optIn, playAudio, stopAudio, AUDIO_TOUR, AUDIO_PLAY } from 'aria-viewer/audiomanager/audioManagerActions'
import { audioButtonClicked } from 'aria-viewer/analytics/analyticActions'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { TourActions } from 'aria-viewer/tour/constants'
import { showAvatar, hideAvatar } from 'aria-viewer/guide/avatarActions'

const hideDescription = () => ({
    type: TourActions.SHOW_DESCRIPTION,
    visible: false,
})

export const showDescription = () => ({
    type: TourActions.SHOW_DESCRIPTION,
    visible: true,
})

class DesktopAudioButton extends PureComponent {
    constructor(props) {
        super(props)
    }

    onClick = () => {
        this.props.audioButtonClicked()

        if (this.props.audioManager.getIn(['state', AUDIO_TOUR]) === AUDIO_PLAY) {
            this.props.stopAudio(AUDIO_TOUR)
            // FS18-1438: if hiding avatar, make sure description is shown
            this.props.showDescription()
            this.props.hideAvatar()
        } else {
            this.props.playAudio(AUDIO_TOUR)
            this.props.optIn()
            // FS18-1438: if showing avatar, make sure description is hidden
            this.props.hideDescription()
            this.props.showAvatar()
        }
    }

    render() {
        return this.props.isAudioButtonVisible ? (
            <AudioButton
                style={{
                    ...styleguide.buttons.desktop_rounded_button,
                    background: 'transparent',
                    boxShadow: 'none',
                }}
                onClick={this.onClick}
                onIcon="speaker_on"
                offIcon="speaker_off"
                puresvg={true}
                desktop={true}
            />
        ) : null
    }
}

export default connect(
    mapSelectorsToProps(['audioManager', 'isAudioButtonVisible']),
    {
        playAudio,
        stopAudio,
        optIn,
        audioButtonClicked,
        hideDescription,
        showDescription,
        showAvatar,
        hideAvatar,
    }
)(DesktopAudioButton)
